Kubrick.Gallery = {
  _selector: ".gallery",
  _imageSelector: ".thumb",

  _configs: [],
  _controllers: [],

  start: function(config) {
    Kubrick._log("Gallery: Configuring...", config);
    var $GALLERY = document.querySelector("#content ." + config.id);
    var $MODAL = document.querySelector("#content #" + config.modal_id);
    if ($GALLERY && $MODAL) {
      this._setupGallery($GALLERY, $MODAL);
      this._configs.push(config);
    }
  },

  nextGalleryImage: function(controller) {
    let active = controller.$MODAL.querySelector(".image");
    if (active) {
      let url = active.getAttribute("data-full-image");
      var thumbs = controller.$GALLERY.querySelectorAll(".item .image");
      var activeThumb = controller.$GALLERY.querySelector(
        ".item .thumb[data-full-image*='" + active.getAttribute("src") + "']"
      );
      var nextThumb = activeThumb.parentNode.nextElementSibling.querySelector(
        ".thumb"
      );
      if (!nextThumb) {
        nextThumb = activeThumb.parentNode.parentNode.querySelector(
          ".item:first-of-type .thumb"
        );
      }
      nextThumb.click();
    }
  },

  prevGalleryImage: function(controller) {
    let active = controller.$MODAL.querySelector(".image");
    if (active) {
      let url = active.getAttribute("data-full-image");
      var thumbs = controller.$GALLERY.querySelectorAll(".item .image");
      var activeThumb = controller.$GALLERY.querySelector(
        ".item .thumb[data-full-image*='" + active.getAttribute("src") + "']"
      );
      console.log(
        active,
        activeThumb,
        activeThumb.parentNode.previousElementSibling
      );
      var prevItem = activeThumb.parentNode.previousElementSibling;
      if (!prevItem) {
        prevItem = activeThumb.parentNode.parentNode.querySelector(
          ".item:last-of-type"
        );
      }
      prevItem.querySelector(".thumb").click();
    }
  },

  _setupGallery: function($GALLERY, $MODAL) {
    Kubrick._log("Gallery: Setup...", $GALLERY);
    var controller = {
      $GALLERY: $GALLERY,
      $MODAL: $MODAL,
      $THUMBS: $GALLERY.querySelectorAll(this._imageSelector)
    };
    controller.$PREV = $MODAL.querySelector("button.previous");
    controller.$NEXT = $MODAL.querySelector("button.next");
    controller.$NEXT.addEventListener(
      "click",
      function(e) {
        this.nextGalleryImage(controller);
      }.bind(this)
    );

    controller.$PREV.addEventListener(
      "click",
      function(e) {
        this.prevGalleryImage(controller);
      }.bind(this)
    );

    for (let i = 0; i < controller.$THUMBS.length; i++) {
      var $THUMB = controller.$THUMBS[i];
      var id = $THUMB.getAttribute("aria-controls");

      $THUMB.addEventListener("click", function(e) {
        Kubrick._log("Gallery: Show...", this);
        var path = this.getAttribute("data-full-image");
        Kubrick.Gallery._setupImageModal($MODAL, path, this);
        Kubrick.Modals.openModal($MODAL);
      });
    }
  },

  _setupImageModal: function($MODAL, imagePath, $THUMB) {
    var image = document.createElement("img");
    image.src = imagePath;
    image.classList.add("image", "fit");
    image.style.opacity = 0;
    image.addEventListener(
      "load",
      function() {
        // Animate
        anime({
          targets: image,
          opacity: [0, 1],
          duration: 1000,
          easing: Kubrick.EASING.NORMAL
        });
      },
      false
    );
    var existing = $MODAL.querySelector(".image");
    if (existing) {
      existing.remove();
    }
    $MODAL.querySelector(".fullsize-image").appendChild(image);
  }
};
